export default __webpack_public_path__ + "static/media/petgramImg_4.39eed024.png";